// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2YO3L","header":"MergedInvoice_header__2Iu0z"};